(function($) {

  $('.featured-team-member > .featured-image').each(function() {
  	$(this).magnificPopup({
		type: 'inline',
		items: [
			{
				src: '#'+$(this).attr('data-team-member'),
				type: 'inline'
			}
		],
		closeOnBgClick: true,
  		fixedContentPos: false,
		closeOnContentClick: false,
		showCloseBtn: true,
		closeBtnInside: true,
		enableEscapeKey: false,
		callbacks: {
			beforeOpen: function() {
				startWindowScroll = $(window).scrollTop();
				$('html').addClass('modal-open');
			},
			open: function(){
				if ( $('.mfp-content').height() < $(window).height() ){
				  $('html').on('touchmove', function (e) {
				      e.preventDefault();
				  });
				}
			},
			close: function() {
				$(window).scrollTop(startWindowScroll);
				$('html').removeClass('modal-open');
			}
		}
	});
  });


})(jQuery);
